<template>
  <v-container class="pr-0 pl-0" fluid>
    <v-row
      justify="center"
      align="start"
      class="mb-10"
    >
      <v-col
        v-for="item in allNoticias"
        :key="item.id"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <v-card class="elevation-5 mb-4">
          <v-img
            :src="item.photoUrl"
            class="text-white align-end fill-height elevation-10"
            gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,.9)"
          >
            <v-card-text class="title font-weight-black">
              <span class="news-title-text">{{ item.titulo }}</span>
            </v-card-text>
          </v-img>
          <v-card-actions class="grey darken-3">
            <v-spacer></v-spacer>
            <v-btn
              color="primary mr-2 mb-2"
              fab
              dark
              x-small
              @click="abreNoticia(item)"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="selectedNoticia != null">
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ selectedNoticia.titulo }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-heart-outline</v-icon>
            </v-btn>
            <v-btn icon dark @click="fechaNoticia()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-5">
            <v-row>
              <v-col
                cols="12"
                v-if="selectedNoticia.media != null"
              >
                <img :src="selectedNoticia.media.url" class="w-100" />
              </v-col>
              <v-col
                cols="12"
                v-html="selectedNoticia.texto"
              ></v-col>

              <v-col
                cols="12"
                class="justify-center"
                v-if="selectedNoticia.url != null && selectedNoticia.url != ''"
              >
                <v-btn color="primary" width="100%">
                  Link para a notícia
                  <v-icon right dark>mdi-web</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import HOST from "../ws";

export default {
  props: {
    source: String
  },
  data: () => ({
    myHost: HOST.HOST,
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false,
    allNoticias: [],
    selectedNoticia: null,
  }),
  mounted() {
    // Load news articles
    this.$store.commit("setLoader", true);
    const config = {
      headers: { Authorization: `Bearer ${this.$store.state.currentToken}` }
    };
    axios
      .post(this.myHost + "/noticia/all", {}, config)
      .then(response => {
        this.allNoticias = response.data;
        this.$store.commit("setLoader", false);
      })
      .catch(error => {
        console.log(error.message);
        this.$store.commit("setLoader", false);
        // Uncomment to handle logout or redirect on error
        // this.$store.commit("logout");
        // this.$router.push("login");
      });
  },
  methods: {
    abreNoticia(val) {
      window.open(val.url, '_blank');
    },
    fechaNoticia() {
      this.selectedNoticia = null;
      this.dialog = false;
    }
  }
};
</script>

<style scoped>
.news-title-text {
  color: rgb(214, 221, 214);
}
</style>
